// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XTE_","question":"styles_question__ITcTC","description":"styles_description__3D5nH"};